// ⚠️  instrument.ts DOIT être le premier import
import './instrument';

import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';

const container = document.getElementById('root')!;

const root = createRoot(container, {
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
